import React from 'react'

import ContactMethodSelect from '../../../../ui/select/ContactMethodSelect'

const ContactMethodsField = ({
  contactMethods = [],
  selectedMethods,
  values,
  setFieldValue,
}) => {
  const handleSelect = opt => {
    const value = opt?.value || opt
    if (!value) return

    const selectedObj = contactMethods.find(m => m.name === value)
    if (!selectedObj) return

    const currentMethods = values.contact_methods || []
    const isDuplicate = currentMethods.some(m => m.id === selectedObj.id)

    if (!isDuplicate) {
      setFieldValue('contact_methods', [...currentMethods, selectedObj])
    }
  }

  const handleRemove = idx => {
    const currentMethods = values.contact_methods || []
    setFieldValue(
      'contact_methods',
      currentMethods.filter((_, i) => i !== idx)
    )
  }

  const handleClear = () => {
    setFieldValue('contact_methods', [])
  }

  return (
    <ContactMethodSelect
      options={contactMethods.map(m => m.name)}
      initialSelected={selectedMethods}
      onSelect={handleSelect}
      onRemove={handleRemove}
      onClear={handleClear}
      inputProps={{ id: 'contact-methods-multiselect' }}
    />
  )
}

export default ContactMethodsField
